import * as React from 'react';

function IconStatusInfoSmall(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M8 2C6.81331 2 5.65327 2.35189 4.66658 3.01118C3.67988 3.67047 2.91085 4.60754 2.45672 5.7039C2.0026 6.80026 1.88378 8.00666 2.11529 9.17054C2.3468 10.3344 2.91824 11.4035 3.75736 12.2426C4.59647 13.0818 5.66557 13.6532 6.82946 13.8847C7.99334 14.1162 9.19974 13.9974 10.2961 13.5433C11.3925 13.0892 12.3295 12.3201 12.9888 11.3334C13.6481 10.3467 14 9.18669 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2ZM9 12H7V8H6V7H9V12ZM8 6C7.80222 6 7.60888 5.94135 7.44443 5.83147C7.27998 5.72159 7.15181 5.56541 7.07612 5.38268C7.00043 5.19996 6.98063 4.99889 7.01921 4.80491C7.0578 4.61093 7.15304 4.43275 7.29289 4.29289C7.43274 4.15304 7.61093 4.0578 7.80491 4.01921C7.99889 3.98063 8.19996 4.00043 8.38268 4.07612C8.56541 4.15181 8.72159 4.27998 8.83147 4.44443C8.94135 4.60888 9 4.80222 9 5C9 5.26522 8.89464 5.51957 8.70711 5.70711C8.51957 5.89464 8.26522 6 8 6Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconStatusInfoSmall;
